import { render } from "./SchedulerCourier.vue?vue&type=template&id=3250a54a"
import script from "./SchedulerCourier.vue?vue&type=script&lang=js"
export * from "./SchedulerCourier.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/SchedulerCourier.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3250a54a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3250a54a', __exports__)) {
    api.reload('3250a54a', __exports__)
  }
  
  module.hot.accept("./SchedulerCourier.vue?vue&type=template&id=3250a54a", () => {
    api.rerender('3250a54a', render)
  })

}


export default __exports__